import React, { PureComponent } from 'react';
import { Button, message } from 'antd';
import style from './index.less';

class TimeButton extends PureComponent {
  state = {
    sending: false,
    time: 60,
    timer: null
  };

  reset = () => {
    clearTimeout(this.timer);
    this.setState({ time: 60, sending: false });
  };

  timeChange = () => {
    // eslint-disable-next-line react/no-access-state-in-setstate
    const newTime = this.state.time - 1;
    if (newTime === 0) {
      this.setState({ time: 60, sending: false });
      return;
    }
    this.setState({ time: newTime });
    this.timer = window.setTimeout(() => {
      this.timeChange();
    }, 1000);
  };

  onSendClick = () => {
    const { tel, onSend } = this.props;
    if (!/^1\d{10}$/.test(tel)) {
      message.error('请输入正确的手机号');
      return;
    }
    onSend();
    this.setState({ sending: true });
    this.timeChange();
  };

  render() {
    const { sending, time } = this.state;
    const { className } = this.props;

    let text = '';

    if (!sending) {
      text = '发送验证码';
    } else {
      text = `${time}秒后发送`;
    }

    return (
      <Button
        size="large"
        className={`${className} ${style.btn}`}
        disabled={sending}
        type="primary"
        onClick={this.onSendClick}>
        {text}
      </Button>
    );
  }
}

TimeButton.defaultProps = {
  onSend: () => null,
  className: '',
  tel: ''
};

export default TimeButton;
